import { IMapConfiguration, IStaticMapConfiguration } from "./IMapConfiguration";
import { IMapSize } from "./static-map.interface";

/**
 * wenji is a global var containing config info from admin interface
 */
declare const wenji: IWenji;

const fakeWenji = wenji;

export { fakeWenji as wenji };

export interface IWenji {
    ui: {
        language: string;
        target: string;
        dateFormat: string; //for now, has to be JSON?parsed.
        /** Server timezone. */
        timezone: string;
        travellerCollapse?: {
            link: number;
            open: number;
        }
        map: IMapConfiguration;
        staticMap: IStaticMapConfiguration;
        flutterStyle: IFlutterStyle;
    };
    sentry: {
        dsn?: string,
        showReportDialog: boolean,
    };
    appList: string[];
    iaqobohotel?: IAppConfig;
    locobook?: IiqbaConfig;
    sasha?: ISashaConfig;
    synchronyme?: IAppConfig;
    watabi?: IWatabiConfig;
    quotation?: IQuotationConfig;
    osman?: {
        externalWatabiLink: string;
    };
    dashboard?: IDashboardConfig;
    watabilight?: IWatabilightConfig;
    connect?: IConnectConfig;
	air?: {
		airInstanceUrl: string;
	}
}

export interface IConnectConfig {
    clientId: string;
    clientSecret: string;
    url: string;
    bypass: boolean;
    hideLoginLinks: boolean;
}

export interface IFlutterStyle {
    buttons: IFlutterStyleButtons;
    headers: IFlutterStyleItem;
}
export interface IFlutterStyleButtons {
    headerMainButton: IFlutterStyleItem;
    headerLinkButton: IFlutterStyleItem;
    mainButton: IFlutterStyleItem;
    linkButton: IFlutterStyleItem;
}

export interface IFlutterStyleItem {
    backgroundColor: string;
    textColor: string;
}

export interface IOsmanConfig {
    externalWatabiLink: string;
}
export interface IAppConfig {
    code: string;
    name: string;
    icon: string;
    traveller?: IQuantity;
    rooming?: IQuantity;
    api?: any;
    wording?: any;
    search?: any;
    withGiata?: boolean;
    preferHostProperty?: boolean;
    checkJourney?: boolean;
}

export interface IQuotationConfig extends IAppConfig {
    retailCalculationMode: CalculationMode;
    createSupplier: '0' | '1';
}

export interface IiqbaConfig extends IAppConfig {
    search: {
        daysroundtrip: string;
        departuresFlexibility: number;
        results: SearchResultOption;
        xMoment: boolean;
    };
    carrierLogos: string;
    vcc: boolean;
}

export enum SearchResultOption {
    list = 'list',
    summary = 'summary'
}

export interface ISashaConfig {
    qualityCheck: { checks: [] };
    name: string;
    icon: string;
    services: ISashaConfigServices;
}

export interface ISashaConfigServices {
    chargeable: ISashaConfigServicesChargeable;
    free: ISashaConfigServicesFree;
}

export interface ISashaConfigServicesFree {
    codes: string[];
}

export interface ISashaConfigServicesChargeable {
    enabled: boolean;
    xCategories: string[];
}

export interface IQualityCheckId {
    wuiId: string;
}

export interface IWatabiConfig {
    map: {
        static: IMapSize;
        allowNoCoordinatesLocations: '1' | '0';
    };
    quotation: {
        validityInDays: number;
    };
    blocks: {
        features : IBlockFeature[];
        companyCode: string;
        externalServices: IExternalServices[];
        typoPerHost: ITypoPerHost[];
    };
    airSearchEngine: {
        urlRedirectionTarget: string;
        hostsDefault: string;
    };
    user: {
        login: string;
    };
    contract: {
        openPeriodLimit : number;
        openServicesLimit : number;
        openPriceLimit : number;
    };
}

export interface IBlockFeature {
    code: string;
    icon: string;
    features: {
        [key: string] : boolean;
    };
    externalService: {
        icon: string;
        type: string;
    };
}

export interface IExternalServices {
    code: string;
    data: {
        module: string;
        hosts: string[];
        icon: string
    };
}

export interface ITypoPerHost {
    code: string;
    module: string;
    data: ITypoPerHostData[];
}

export interface ITypoPerHostData {
    type: string;
    label: string;
    name: string;
    values?: string[];
    hint?: string;
    placeholder?: string;
    regex?: string;
    addOnURL?: boolean;
}


export interface IQuantity {
    adult: number;
    child: number;
    infant: number;
    rooming?: number;
}

export enum CalculationMode {
    margin = 'margin',
    markup = 'markup',
    rebate = 'rebate',
    commission = 'commission'
}

export interface IDashboardConfig extends IAppConfig {
    config: any;
}

export interface IWatabilightConfig {
    app: IAppConfig;
    user: {
        uid: string;
        pwd: string;
    };
    section: string;
}

export interface IWatabiLightSection {
    reference: IWatabiLightSectionDetails;
    price: IWatabiLightSectionDetails;
    traveller: IWatabiLightSectionDetails;
    customer: IWatabiLightSectionDetails;
    agency: IWatabiLightSectionDetails;
    margeResume: IWatabiLightSectionDetails;
    step: IWatabiLightSectionDetails;
}

export interface IWatabiLightSectionDetails {
    title: string;
    description?: string;
    editableFields?: string[];
}
